import { useSelector } from 'react-redux'
import Map from '../../../../common/Map'
import { Element } from '../../../../common/html/element'
import { selectCompanyOverview } from '../../store/slice'

export const MapItem = () => {
  const data = useSelector(
    selectCompanyOverview((overview) => overview?.addressForMap),
  )

  return (
    <Element className="h100">
      <Map address={data} height={200} />
    </Element>
  )
}
